import { createAsyncThunk } from '@reduxjs/toolkit';
import { setColumnFilters } from './searchAndFilterSlice';
import { GetCardsManagementFilterOptionsInput } from 'API';
import { cardService } from 'app/services/card.service';
import { ColumnFilterMap, SortOption } from 'util/filtering/models';

export const retrieveCardsManagementFilterOptions = createAsyncThunk(
  'searchAndFilter/cardsManagement/retrieveFilterOptions',
  async (
    { pageName, paidolId }: GetCardsManagementFilterOptionsInput & { pageName: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const filterOptions = await cardService.getCardsManagementFilterOptions({ input: { paidolId } });
      dispatch(
        setColumnFilters({
          pageName,
          columnFilters: {
            cardGroupId: {
              options: filterOptions?.cardGroupId?.map(({ id, label }) => ({ id, label })),
              key: 'cardGroupId',
              type: 'string',
              name: 'Card Group',
              rule: 'noExcept',
              page: pageName,
              selectedValues: [],
            },
            cardholderName: {
              options: filterOptions?.cardholders?.map(({ id, label }) => ({ id, label })),
              key: 'cardholderName',
              type: 'string',
              name: 'Cardholder',
              rule: 'noExcept',
              page: pageName,
              selectedValues: [],
            },
            name: {
              options: filterOptions?.cardNames?.map(({ id, label }) => ({ id, label })),
              key: 'name',
              type: 'string',
              name: 'Card Name',
              rule: 'noExcept',
              page: pageName,
              selectedValues: [],
            },
            last4: {
              options: filterOptions?.last4?.map(({ id, label }) => ({ id: label, label })),
              key: 'last4',
              type: 'string',
              name: 'Last 4',
              rule: 'noExcept',
              page: pageName,
              selectedValues: [],
            },
            status: {
              options: filterOptions?.status?.map(({ id, label }) => ({ id, label })),
              key: 'status',
              type: 'string',
              name: 'Status',
              rule: 'noExcept',
              page: pageName,
              selectedValues: [],
            },
          },
        })
      );
      return { filterOptions, pageName };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Sorting and column filtering for the cards management page run client-side
// over the in-memory paymentCardList; these thunks no longer dispatch a fetch.
// They exist solely so the searchAndFilterSlice extraReducers update sortOption /
// columnFilters via the existing .pending listeners. See SEE-904.

export const applyCardsColumnFilters = createAsyncThunk(
  'searchAndFilter/cardsManagement/applyColumnFilters',
  async (_args: { pageName: string; columnFilters: ColumnFilterMap }) => {
    return;
  }
);

export const applyCardsSortFilter = createAsyncThunk(
  'searchAndFilter/cardsManagement/applySortFilter',
  async (_args: { pageName: string; sortOption: SortOption }) => {
    return;
  }
);

export const executeCardsSearch = createAsyncThunk(
  'searchAndFilter/cardsManagement/executeSearch',
  async (_pageName: string) => {
    return;
  }
);
